import { Component, OnInit } from '@angular/core';
import { ConfigServiceService } from 'src/app/config/shared/config-service.service';
import { ConfigService } from 'src/app/config/shared/config.service';
import { NavigationService } from 'src/app/shared/navigation/navigation.service';

@Component({
  selector: 'wl-coupon-add-dialog',
  templateUrl: './coupon-add-dialog.component.html',
  styleUrls: ['./coupon-add-dialog.component.less'],
    standalone: false
})
export class CouponAddDialogComponent implements OnInit {
  show = false;
  constructor(
    private _navigationService: NavigationService,
    private _configService: ConfigService,
    private _configServiceService: ConfigServiceService
  ) {}

  ngOnInit(): void {}

  public open() {
    this.show = true;
  }

  navigateToLegacyCouponPage(profileId: number) {
    Promise.all([this._configService.hasBetaFeatureEnabled('MemberPortal'), this._configServiceService.getWebComponentSettings()]).then(
      ([portal, webComp]) => {
        if (portal || webComp.RedirectLegacyToNew) {
          this._navigationService.navigateToModernCouponAdmin(profileId);
        } else {
          this._navigationService.navigateToLegacyCouponCrudPage(profileId);
        }
      }
    );
  }
}
